"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMetricsAttribute = generateMetricsAttribute;
exports.MetricsTracker = void 0;

var _utils = require("@sm/utils");

var _enums = _interopRequireDefault(require("./types/enums"));

var _utils2 = _interopRequireDefault(require("./utils"));

var _helpers = require("./helpers");

var _DataAnalyticsMetricsSubscriber = _interopRequireDefault(require("./subscribers/DataAnalyticsMetricsSubscriber"));

var _LoggingMetricsSubscriber = _interopRequireDefault(require("./subscribers/LoggingMetricsSubscriber"));

var _GTMMeticsSubscriber = _interopRequireDefault(require("./subscribers/GTMMeticsSubscriber"));

var _FacebookPixelSubscriber = _interopRequireDefault(require("./subscribers/FacebookPixelSubscriber"));

var _MixPanelSubscriber = _interopRequireDefault(require("./subscribers/MixPanelSubscriber"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _getClientEnvironment = (0, _utils.getClientEnvironmentDetails)(),
    isBrowser = _getClientEnvironment.isBrowser; // Import/require only in the browser


var delegatedEvents = isBrowser ? require('delegated-events') : null;

function getCleanDigitalData() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
  return {
    page: {
      pageInfo: {
        pageId: '',
        attributes: {},
        pathname: ''
      }
    },
    events: [],
    components: [],
    user: {
      ep201: (0, _utils2["default"])('ep201'),
      ep202: (0, _utils2["default"])('ep202'),
      id: userId
    }
  };
}

function generateMetricsAttribute(eventData) {
  return JSON.stringify({
    name: eventData.name || _enums["default"].ELEMENT_INTERACTION,
    data: eventData.data
  });
}

var GLOBAL_KEY = 'sm_metrics_tracker_do_not_touch_this';
var glob = isBrowser ? window : global;

function setupRoot() {
  if (!glob[GLOBAL_KEY]) {
    var root = {
      subscribers: [],
      automaticSubscribers: [],
      config: {
        user: {
          id: '',
          isAuthenticated: false
        },
        dataAnalyticsAPIPath: null,
        loggingAPIPath: null,
        country: 'GB',
        legacyWeb: '',
        gtmId: ''
      },
      digitalData: getCleanDigitalData()
    };
    glob[GLOBAL_KEY] = root;
  }

  return glob[GLOBAL_KEY];
}

function getRoot() {
  if (!glob[GLOBAL_KEY]) {
    throw new Error('Please initialize MetricsTracker with a userId before tracking events.');
  }

  return glob[GLOBAL_KEY];
}

var MetricsTracker = {
  initialize: function initialize(config) {
    var root = setupRoot();
    root.config = config;
    root.digitalData = getCleanDigitalData(config.user.id);
    setupEvents();
    return root;
  },
  reset: function reset() {
    var root = getRoot();
    root.digitalData = getCleanDigitalData(root.config.user.id);
    root.subscribers = [];
    root.automaticSubscribers = []; // Add the mandatory dataAnalytics subscriber

    this.addSubscriber(_DataAnalyticsMetricsSubscriber["default"]); // Add the mandatory logging subscriber

    this.addSubscriber(_LoggingMetricsSubscriber["default"]); // Add Google Tag Manager dataLayer subscriber

    MetricsTracker.addSubscriber(_GTMMeticsSubscriber["default"]); // Add Facebook Pixel subscriber

    MetricsTracker.addSubscriber(_FacebookPixelSubscriber["default"]); // Add MixPanel Subscriber

    MetricsTracker.addSubscriber(_MixPanelSubscriber["default"]); // Add MixPanel Automatic Subscriber

    MetricsTracker.addAutomaticSubscriber(_MixPanelSubscriber["default"]);
    return root;
  },
  update: function update(config) {
    // for some data points within an SPA, the configuration must be
    // updated post initialization
    var root = getRoot();
    root.config = _objectSpread(_objectSpread({}, root.config), config);
    return root;
  },
  getSubscribers: function getSubscribers() {
    var _getRoot = getRoot(),
        subscribers = _getRoot.subscribers;

    return subscribers;
  },
  getAutomaticSubscribers: function getAutomaticSubscribers() {
    var _getRoot2 = getRoot(),
        automaticSubscribers = _getRoot2.automaticSubscribers;

    return automaticSubscribers;
  },
  track: function track(event) {
    var _event$data, _event$data2, _event$data2$data;

    var root = getRoot();

    if (root.config.user.id === '') {
      throw new Error('Please initialize MetricsTracker with a userId before tracking events.');
    }

    var maskedEvent = event; // mask email addresses

    if (event !== null && event !== void 0 && (_event$data = event.data) !== null && _event$data !== void 0 && _event$data.email) {
      maskedEvent.data.email = (0, _helpers.maskEmail)(event.data.email);
    }

    if (event !== null && event !== void 0 && (_event$data2 = event.data) !== null && _event$data2 !== void 0 && (_event$data2$data = _event$data2.data) !== null && _event$data2$data !== void 0 && _event$data2$data.email) {
      maskedEvent.data.data.email = (0, _helpers.maskEmail)(event.data.data.email);
    }

    if (_enums["default"][event.name]) {
      root.digitalData.events.push(event);

      if (_enums["default"].COMPONENT_ADD === event.name) {
        root.digitalData.components.push(event.data);
      }

      if (event.name === _enums["default"].PAGE_VIEW || event.name === _enums["default"].VIRTUAL_PAGE_VIEW) {
        root.digitalData = (0, _helpers.pageViewMutation)(event, root.digitalData);
      }

      root.subscribers.forEach(function (subscriber) {
        subscriber(event, root.config);
      });
    }
  },
  automaticTrack: function automaticTrack(event) {
    var root = getRoot();
    root.automaticSubscribers.forEach(function (subscriber) {
      subscriber(event, root.config);
    });
  },
  addSubscriber: function addSubscriber(subscriber) {
    /**
     * We always want to allow the subscribers to subscribe. If the user
     * did not accept GDPR, we don't fire events; hence, we never violate GDPR.
     * If, however, the user does allow tracking, we don't want to subscribers
     * to re-subscribe.
     */
    var root = getRoot();
    root.subscribers.push(subscriber);
  },
  addAutomaticSubscriber: function addAutomaticSubscriber(subscriber) {
    var root = getRoot();
    root.automaticSubscribers.push(subscriber);
  },
  getConfig: function getConfig() {
    return getRoot().config;
  },
  getDigitalData: function getDigitalData() {
    return getRoot().digitalData;
  }
};
exports.MetricsTracker = MetricsTracker;

function setupEvents() {
  if (!isBrowser) {
    return;
  }

  if (window && window.SM && window.SM.MetricsTracker) {
    // only create one event listener on the document
    // this makes it safe for consumer apps to call initialize multiple times
    return;
  }
  /**
   * Add on click event listener
   * Note - this is done in the getInstance method; hence, until this
   * method is called, the event handler would never be bound.
   */


  delegatedEvents.on('click', '[data-sm-metrics]', function gce(event) {
    if (event && event.currentTarget) {
      var metricsData = event.currentTarget.getAttribute('data-sm-metrics');

      if (metricsData) {
        var metricsDataJSON = JSON.parse(metricsData);
        var eventData = metricsDataJSON.data;
        MetricsTracker.track({
          name: metricsDataJSON.name || _enums["default"].ELEMENT_INTERACTION,
          data: eventData
        });
      }
    }
  }); // Add the mandatory dataAnalytics subscriber

  MetricsTracker.addSubscriber(_DataAnalyticsMetricsSubscriber["default"]); // Add the mandatory logging subscriber

  MetricsTracker.addSubscriber(_LoggingMetricsSubscriber["default"]); // Add Google Tag Manager dataLayer subscriber

  MetricsTracker.addSubscriber(_GTMMeticsSubscriber["default"]); // Add Facebook Pixel subscriber

  MetricsTracker.addSubscriber(_FacebookPixelSubscriber["default"]); // Add MixPanel Subscriber

  MetricsTracker.addSubscriber(_MixPanelSubscriber["default"]);
  setupAutomaticEvents();
  window.SM = window.SM || {};
  window.SM.MetricsTracker = MetricsTracker;
}

function setupAutomaticEvents() {
  var clickableLinks = ['.wds-button', '.wds-link', 'a', 'wds-switch__native', 'wds-checkbox__native', 'wds-radio__native', 'wds-list__item', 'wds-close', 'wds-popout__trigger', 'wds-has-menu', 'wds-slider__handle', 'wds-tab__tab-btn'];
  delegatedEvents.on('click', clickableLinks.join(','), function gce(event) {
    if (!event.target) {
      return;
    }

    var name = event.type;
    var target = event.target;
    var inputTarget = target;
    MetricsTracker.automaticTrack({
      name: _enums["default"].ELEMENT_INTERACTION,
      data: {
        actionType: name,
        actionFlow: 'automatic',
        "class": target.className,
        text: target.innerText,
        checked: inputTarget.checked || undefined,
        value: inputTarget.value || undefined
      }
    });
  }); // Add MixPanel Subscriber

  MetricsTracker.addAutomaticSubscriber(_MixPanelSubscriber["default"]);
}